/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `Default: Type` - DEFAULT_KIND
 * * `Default: Title` - DEFAULT_TITLE
 * * `Default: Description` - DEFAULT_DESCRIPTION
 * * `Default: Dartboard` - DEFAULT_DARTBOARD
 * * `Default: Status` - DEFAULT_STATUS
 * * `Default: Assignees` - DEFAULT_ASSIGNEES
 * * `Default: Dates` - DEFAULT_DATES
 * * `Default: Priority` - DEFAULT_PRIORITY
 * * `Default: Tags` - DEFAULT_TAGS
 * * `Default: Size` - DEFAULT_SIZE
 * * `Default: Time tracking` - DEFAULT_TIME_TRACKING
 * * `Default: Reviewers` - DEFAULT_REVIEWERS
 * * `Default: Attachments` - DEFAULT_ATTACHMENTS
 * * `Default: Created` - DEFAULT_CREATED_AT
 * * `Default: Created by` - DEFAULT_CREATED_BY
 * * `Default: Last updated` - DEFAULT_UPDATED_AT
 * * `Default: Last updated by` - DEFAULT_UPDATED_BY
 * * `Default: Completed` - DEFAULT_COMPLETED_AT
 * * `Select` - SELECT
 * * `Multiselect` - MULTISELECT
 * * `Status` - STATUS
 * * `User` - USER
 * * `Dates` - DATES
 * * `Time tracking` - TIME_TRACKING
 * * `Text` - TEXT
 * * `Number` - NUMBER
 * * `Checkbox` - CHECKBOX
 */
export enum PropertyKind {
  DEFAULT_KIND = 'Default: Type',
  DEFAULT_TITLE = 'Default: Title',
  DEFAULT_DESCRIPTION = 'Default: Description',
  DEFAULT_DARTBOARD = 'Default: Dartboard',
  DEFAULT_STATUS = 'Default: Status',
  DEFAULT_ASSIGNEES = 'Default: Assignees',
  DEFAULT_DATES = 'Default: Dates',
  DEFAULT_PRIORITY = 'Default: Priority',
  DEFAULT_TAGS = 'Default: Tags',
  DEFAULT_SIZE = 'Default: Size',
  DEFAULT_TIME_TRACKING = 'Default: Time tracking',
  DEFAULT_REVIEWERS = 'Default: Reviewers',
  DEFAULT_ATTACHMENTS = 'Default: Attachments',
  DEFAULT_CREATED_AT = 'Default: Created',
  DEFAULT_CREATED_BY = 'Default: Created by',
  DEFAULT_UPDATED_AT = 'Default: Last updated',
  DEFAULT_UPDATED_BY = 'Default: Last updated by',
  DEFAULT_COMPLETED_AT = 'Default: Completed',
  SELECT = 'Select',
  MULTISELECT = 'Multiselect',
  STATUS = 'Status',
  USER = 'User',
  DATES = 'Dates',
  TIME_TRACKING = 'Time tracking',
  TEXT = 'Text',
  NUMBER = 'Number',
  CHECKBOX = 'Checkbox',
}
